<div class="container-fluid">
  <app-page-header
    title="Contatos Qualificados"
    icon="fas fa-user-check"
    subtitle="Gerencie os contatos qualificados do sistema">
  </app-page-header>
@if (error || erro403) {
  @if(erro403){
    <app-no-access></app-no-access>
  } @else {
    <div class="col-12">
      <div class="alert alert-danger" role="alert">{{ error }}</div>
    </div>
  }
} @else {
  <!-- Filtros -->
  <div class="card mb-4" id="tour-filtros">
    <div class="card-header">
      <h5 class="card-title mb-0">
        <i class="fas fa-filter me-2"></i>
        Filtros
      </h5>
    </div>
    <div class="card-body">
      <form [formGroup]="filterForm">
        <div class="row g-3">
          <div class="col-md-3" id="tour-filtro-cliente">
            <label for="Cliente" class="form-label">Cliente</label>
            <input
              type="text"
              id="Cliente"
              class="form-control form-control-sm"
              formControlName="Cliente"
              placeholder="Filtrar por cliente"
            >
          </div>
          <div class="col-md-3">
            <label for="Feiras" class="form-label">Feira</label>
            <input
              type="text"
              id="Feiras"
              class="form-control form-control-sm"
              formControlName="Feiras"
              placeholder="Filtrar por feira"
            >
          </div>
          <div class="col-md-3" id="tour-filtro-status">
            <label for="Status" class="form-label">Status</label>
            <div class="position-relative">
              <input
                type="text"
                id="Status"
                class="form-control form-control-sm"
                [(ngModel)]="buscaStatus"
                [ngModelOptions]="{standalone: true}"
                (input)="onInputStatus()"
                (focus)="abrirDropdownStatus()"
                (blur)="fecharDropdownStatus()"
                placeholder="Selecione um status..."
                autocomplete="off"
              >
              
              <!-- Dropdown de status -->
              <div *ngIf="dropdownStatusAberto && statusFiltrados.length > 0" 
                   class="dropdown-menu show position-absolute w-100" 
                   style="max-height: 200px; overflow-y: auto; z-index: 1000;">
                <a
                  *ngFor="let status of statusFiltrados"
                  class="dropdown-item"
                  href="#"
                  (click)="selecionarStatus(status); $event.preventDefault()"
                  (mousedown)="$event.preventDefault()"
                >
                  {{ getStatusNome(status) }}
                </a>
              </div>
              <div *ngIf="dropdownStatusAberto && statusFiltrados.length === 0" 
                   class="dropdown-menu show position-absolute w-100" 
                   style="z-index: 1000;">
                <div class="dropdown-item-text text-muted">Nenhum status encontrado</div>
              </div>
            </div>
            <!-- Hidden select para manter a validação do formulário -->
            <select
              id="StatusHidden"
              class="d-none"
              formControlName="Status"
            >
              <option [ngValue]="''">Todos</option>
              <option *ngFor="let status of statusMessages" [ngValue]="status.id">
                {{ getStatusNome(status) }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <label for="Contato" class="form-label">Contato</label>
            <input
              type="text"
              id="Contato"
              class="form-control form-control-sm"
              formControlName="Contato"
              placeholder="Filtrar por contato"
            >
          </div>
        </div>
        <div class="row g-3">
          <div class="col-md-2">
            <label for="QuantidadePorPagina" class="form-label">Itens por página</label>
            <select
              id="QuantidadePorPagina"
              class="form-select form-select-sm"
              formControlName="Paginacao.QuantidadePorPagina"
            >
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
            </select>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12 d-flex justify-content-end">
            <button
              type="button"
              id="tour-botao-limpar-filtros"
              class="btn btn-outline-secondary btn-sm"
              (click)="limparFiltros()"
            >
              <i class="fas fa-eraser me-1"></i>
              Limpar filtros
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Carregando...</span>
    </div>
    <p class="mt-2 text-muted">Carregando contatos qualificados...</p>
  </div>

  <!-- Lista -->
  <div *ngIf="!isLoading" class="card" id="tour-tabela-contatos">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="card-title mb-0">
        <i class="fas fa-list me-2"></i>
        Contatos Qualificados ({{ pagination.totalDeItens }})
      </h5>
    </div>
    <div class="card-body p-0">
      <div *ngIf="lists.length === 0" class="text-center py-5">
        <i class="fas fa-users fa-3x text-muted mb-3"></i>
        <h5 class="text-muted mb-0">Nenhum contato qualificado encontrado</h5>
      </div>

      <div *ngIf="lists.length > 0" class="table-responsive">
        <table class="table table-hover table-striped mb-0">
          <thead class="table-light">
            <tr>
              <th class="px-3 py-2 text-center" id="tour-coluna-acoes">Ações</th>
              <th class="px-3 py-2">Cliente</th>
              <th class="px-3 py-2">Feira</th>
              <th class="px-3 py-2 text-center">Status</th>
              <th class="px-3 py-2">Próximo Contato</th>
              <th class="px-3 py-2">Contato</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of lists; trackBy: trackByContact">
              <td class="px-3 py-2 text-center">
                <div class="btn-group btn-group-sm" role="group">
                  @if(!podeEditar) {
                    <button type="button" class="btn btn-outline-secondary" disabled title="Sem permissão">
                      <i class="fas fa-ban"></i>
                    </button>
                  } @else {
                    <button
                      type="button"
                      class="btn btn-outline-info me-1"
                      [routerLink]="['/clientes', row.clienteId]"
                      title="Visualizar"
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-primary"
                      (click)="open(row)"
                      title="Editar"
                      id="tour-botao-editar"
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                  }
                </div>
              </td>
              <td class="px-3 py-2">
                <strong>{{ row.nomeCliente }}</strong>
              </td>
              <td class="px-3 py-2">
                {{ row.feira || '-' }}
              </td>
              <td class="px-3 py-2 text-center">
                <span *ngIf="row.status" class="badge text-opacity-100 {{ getStatusBadgeClass(row.status) }}">
                  {{ row.status | statusCorFormatter:'nome' }}
                </span>
                <span *ngIf="!row.status" class="text-muted">-</span>
              </td>
              <td class="px-3 py-2">
                {{ row.dataAgendamento | date: 'dd/MM/yyyy HH:mm' }}
              </td>
              <td class="px-3 py-2">
                <div>
                  <strong>{{ row.email || '-' }}</strong>
                </div>
                <div class="small text-muted">
                  {{ row.telefone || '-' }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Paginação -->
    <div *ngIf="lists.length > 0" class="card-footer" id="tour-paginacao">
      <div class="row">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info" role="status" aria-live="polite">
            Mostrando {{ (pagination.paginaAtual - 1) * pagination.quantidadePorPagina + 1 }} até
            {{ (pagination.paginaAtual * pagination.quantidadePorPagina) > pagination.totalDeItens ? pagination.totalDeItens : (pagination.paginaAtual * pagination.quantidadePorPagina) }} de
            {{ pagination.totalDeItens }} registros
          </div>
        </div>
        <div class="col-sm-12 col-md-7">
          <div class="dataTables_paginate paging_simple_numbers">
            <ngb-pagination
              [page]="pagination.paginaAtual"
              [pageSize]="pagination.quantidadePorPagina"
              [collectionSize]="pagination.totalDeItens"
              [maxSize]="5"
              [rotate]="true"
              [boundaryLinks]="true"
              (pageChange)="onPageChange($event)"
              class="pagination-rounded justify-content-end">
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<!-- Botão de Tour -->
<app-tour-button (tourClick)="iniciarTour()"></app-tour-button>
</div>